module.exports = __webpack_public_path__ + "img/meat.b89bb59a.png";